import * as z from "zod"

export const recommendedTaskSchema = z.object({
    instructions: z.string().max(200, 'Instructions must be at most 200 characters').optional(),
    cost: z.string().optional(),
    medications: z.array(z.object({
        medication_name: z.string().optional(),
        dosage: z.string().optional(),
        cost: z.string().optional(),
        refill: z.number().optional(),
    })).optional(),
})

export interface TaskFormType {
    type: string;
    instructions?: string;
    medications?: {
        medication_name?: string;
        dosage?: string;
        duration?: string;
        cost?: string; 
        vitamin?: {
            name?: string
        };
        instructions?: string;
        refill?: number;
    }[]
    cost?: string;
}


